import { render, staticRenderFns } from "./ViewToggle.vue?vue&type=template&id=770a991c&"
import script from "./ViewToggle.vue?vue&type=script&lang=js&"
export * from "./ViewToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports